import React from 'react';
import { connect } from 'react-redux';

//import bridge from "@vkontakte/vk-bridge";

import { Root, View } from '@vkontakte/vkui';
import '@vkontakte/vkui/dist/vkui.css';

import { appInitThunk } from './appInitThunkWeb';

import Preloader from '../preloaderPanel/PreloaderContainer';
import MainPanel from '../mainPanel/MainPanelContainer';

class App extends React.Component {
    
    componentDidMount = () => {
        this.props.onComponentDidMount();
    }
	
    render = () => {
		
        return (
            <MainPanel id="mainPanel" />
        );
    }

}

let mapStateToProps = (state) => ({
    appTitle: state.app.title,
});

let mapDispatchToProps = (dispatch) => {
    
    return {
        setRootPopout: (e) => {
            //dispatch(setRootPopout(e));
        },
        onComponentDidMount: () => {
            dispatch(appInitThunk());
        },
        onMainViewTransition: (e) => {
            //dispatch(onViewTransitionResize(e));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(App)
